export const CircleTickFilledIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="12" fill="#439629" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.7588 7.24115C19.0804 7.56275 19.0804 8.08418 18.7588 8.40579L10.5235 16.6411C10.2019 16.9627 9.68046 16.9627 9.35885 16.6411L5.24121 12.5234C4.9196 12.2018 4.9196 11.6804 5.24121 11.3588C5.56281 11.0372 6.08424 11.0372 6.40585 11.3588L9.94118 14.8941L17.5941 7.24115C17.9158 6.91954 18.4372 6.91954 18.7588 7.24115Z"
      fill="white"
    />
  </svg>
);
